import { connect } from 'react-redux';
import { selectPermission } from '@selectors/authentication';
import { forceSyncRequest } from '@actions/admin';
import SettingsPage from './SettingsPage';

const mapStateToProps = (state) => ({
  isSuperAdmin: selectPermission(state) === 'SuperAdmin',
});

const mapDispatchToProps = {
  forceSyncRequest,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SettingsPage);



// WEBPACK FOOTER //
// ./components/pages/SettingsPage/index.js